import {
    AdsOrOrganicFilterView,
    ContentSearchParams,
    InputMaybe,
    Maybe,
    useGetSummaryForAccountsQuery
} from '../api/client'
import SearchParameters from './content/search/searchParameters'

// This is suboptimal but if the class name is not explicitly written somewhere in the code the styling will get purged by tailwind.
const getTextColour = (severity: string) => {
    if (severity === 'severe') {
        return 'text-severe'
    } else if (severity === 'suspect') {
        return 'text-suspect'
    } else if (severity === 'safe') {
        return 'text-safe'
    } else {
        return 'text-gray-500'
    }
}

type Props = {
    onModerationChange: (moderation: string) => void
    selectedModeration?: string
    searchParameters: SearchParameters
}

type ModerationView = {
    id: string
    display: string
    total?: Maybe<number>
}

function SummaryStatistics(props: Props) {
    const { onModerationChange, selectedModeration, searchParameters } = props

    const params: ContentSearchParams = {
        timeDuration: searchParameters.timeDuration
            ? `${searchParameters.timeDuration.toISOString()}`
            : undefined,
        accountIds: searchParameters.selectedAccountIds,
        authorProfileIds: [],
        teamIds: searchParameters.selectedTeams,
        since: searchParameters.startDateTime,
        before: searchParameters.endDateTime,
        socialMediaServiceIds: searchParameters.selectedSocialMediaServices.map((sms) => sms.id),
        containsText: searchParameters.keyword,
        classifierSearchParams: searchParameters.selectedClassifiers,
        adsOrOrganic: searchParameters.adOrOrganic as
            | InputMaybe<AdsOrOrganicFilterView>
            | undefined,
        contentIds: searchParameters.contentIds,
        postIds: searchParameters.postIds,
        owned: searchParameters.owned,
        readFilter: searchParameters.readReceipt,
        excludeOwnComments: searchParameters.excludeOwnComments,
        dmFilter: searchParameters.dmFilter
    }

    const { data, loading } = useGetSummaryForAccountsQuery({
        variables: {
            params
        },
        onError: (e) => {
            // SOMEDAY : Use the actual logging solution
            console.error(`There was a problem getting the summary for accounts data. ${e}`)
        }
    })

    const moderations: ModerationView[] = [
        {
            id: 'all',
            display: 'All'
        },
        {
            id: 'safe',
            display: 'Safe',
            total: data?.getSummaryForAccounts?.countSafe
        },
        {
            id: 'suspect',
            display: 'Suspect',
            total: data?.getSummaryForAccounts?.countSuspect
        },
        {
            id: 'severe',
            display: 'Severe',
            total: data?.getSummaryForAccounts?.countSevere
        }
    ]

    function handleModerationChange(moderationView: ModerationView) {
        const moderation = moderationView.display.toLowerCase()
        onModerationChange && onModerationChange(moderation)
    }

    return (
        <div>
                <span className={`relative z-0 inline-flex shadow-sm rounded-md ${loading ? 'animate-pulse' : ''}`}>
                    {moderations.map((item, index) => {
                        let roundedClasses = ''
                        if (index === 0) {
                            roundedClasses = 'rounded-l-md'
                        } else if (index === moderations.length - 1) {
                            roundedClasses = 'rounded-r-md'
                        }

                        let classes =
                            'relative inline-flex items-center px-4 py-2 border border-ink-200 bg-white text-sm text-ink-900 hover:bg-ink-50 hover:border-ink-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-arwen-500 focus:border-arwen-500 transition-all duration-150 '
                        if (selectedModeration?.toLowerCase() === item.display?.toLowerCase()) {
                            classes =
                                'relative inline-flex items-center px-4 py-2 bg-ink-100  border border-ink-300 text-sm hover:bg-ink-50 hover:border-ink-300 text-ink-900  focus:z-10 focus:outline-none focus:ring-1 focus:ring-arwen-500 focus:border-arwen-500 transition-all duration-150 '
                        }
                        return (
                            <div key={item.display}>
                                <button
                                    type="button"
                                    onClick={() => handleModerationChange(item)}
                                    className={`${classes} ${roundedClasses}`}
                                    data-cy={`${item.display}-classification-button`}
                                >
                                    {item.display}
                                    {item.total !== null &&
                                    item.total !== undefined &&
                                    item.total >= 0 ? (
                                        <span
                                            className={`ml-2  ${getTextColour(
                                                item.display.toLowerCase()
                                            )}`}
                                        >
                                            ({item.total})
                                        </span>
                                    ) : (
                                        <></>
                                    )}
                                </button>
                            </div>
                        )
                    })}
                </span>
        </div>
    )
}

export default SummaryStatistics
